import React from "react";
import { SVG, IconProps } from "../SVG";
export const SpotList = ({
    spotColor = "#FFD99E",
    color = "#13126C",
    strokeWidth = "2.2",
    ...props
}: IconProps) => (
    <SVG viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <g clipPath="url(#clip0_891_26844)">
            <path
                d="M34.4 39.0759C27.6543 41.8514 22.228 37.8288 15.9438 34.2188C9.53374 30.0024 -0.788691 31.3165 0.0478606 22.8608C0.713188 16.1357 8.45499 15.8335 14.5444 11.8323C20.5986 7.83531 23.2209 5.90416 28.4397 7.63843C33.6233 9.3769 38.5992 12.7457 39.7324 18.8849C40.8302 25.0283 38.4521 36.542 34.4 39.0759Z"
                fill={spotColor}
            />
            <path
                d="M13.3328 10H34.9995M13.3328 20H34.9995M13.3328 30H34.9995M5 10H5.01667M5 20H5.01667M5 30H5.01667"
                stroke={color}
                strokeWidth={strokeWidth}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </g>
    </SVG>
);
SpotList.displayName = "SpotList";
